import React from "react";
import Footer from "./Footer";
import NavBar from "./NavBar";
import { useMediaQuery, useTheme } from "@mui/material";

const AnnualComplianceLLP = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md")); // Mobile breakpoint at 900px

  return (
    <div
      style={{
        fontFamily: "Arial, sans-serif",
        backgroundColor: "#f5f5f5",
        margin: 0,
        padding: 0,
      }}
    >
      <NavBar />

      {/* Header */}
      <div
        style={{
          backgroundColor: "#00b050",
          color: "white",
          padding: isMobile ? "15px" : "30px",
          fontSize: isMobile ? "20px" : "28px",
          fontWeight: "bold",
          textAlign: "center",
          marginTop: "65px",
        }}
      >
        Annual Compliance of LLP
      </div>

      {/* Intro Paragraph */}
      <p
        style={{
          maxWidth: isMobile ? "100%" : "1200px",
          width: "95%",
          margin: isMobile ? "10px auto" : "20px auto",
          padding: isMobile ? "10px" : "20px",
          fontSize: isMobile ? "14px" : "16px",
        }}
      >
        A Limited Liability Partnership (LLP) is recognized as a distinct legal
        entity, obligating its partners to maintain accurate books of accounts
        and submit annual returns to the Ministry of Corporate Affairs (MCA)
        annually.
      </p>

      {/* Content */}
      <div
        style={{
          maxWidth: isMobile ? "100%" : "1200px",
          width: "95%",
          margin: isMobile ? "10px auto" : "15px auto",
          padding: isMobile ? "10px" : "20px",
        }}
      >
        <div
          style={{
            background: "white",
            padding: isMobile ? "15px" : "25px",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
            lineHeight: "1.6",
            color: "#333",
          }}
        >
          {/* Legal Structure */}
          <div>
            <h2
              style={{
                color: "#001F3F",
                fontWeight: 600,
                marginBottom: isMobile ? "4px" : "6px",
                fontFamily: "Times New Roman, Georgia, serif",
                fontSize: isMobile ? "18px" : "24px",
              }}
            >
              Legal Structure
            </h2>
            <div
              style={{
                width: "80px",
                height: "3px",
                background: "#22c55e",
                borderRadius: "2px",
              }}
            ></div>
          </div>

          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            An LLP, registered with the MCA in India, requires at least two
            partners, one of whom must be an Indian citizen and resident.
            Partners are responsible for maintaining proper accounts, filing
            income tax returns, and submitting annual returns to the MCA each
            financial year, from April 1st to March 31st.
          </p>

          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Unlike private limited companies, LLPs are exempt from mandatory
            audits unless their annual turnover exceeds INR 40 lakhs or
            contributions surpass INR 25 lakhs, simplifying the annual filing
            process. However, non-compliance can attract penalties up to INR 5
            lakhs, significantly higher than the INR 1 lakh for companies.
          </p>

          {/* Filing Obligations */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Filing Obligations
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            LLPs must file a Statement of Account & Solvency within 30 days from
            the end of six months of the financial year (by October 30th) and an
            Annual Return within 60 days from the fiscal year-end (by May 30th),
            even if no business is conducted. These filings are mandatory for
            all registered LLPs, including dormant or closed ones.
          </p>

          {/* Audit Requirements */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Audit Requirements
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            LLPs are generally not required to audit their books unless their
            turnover exceeds INR 40 lakhs or contributions exceed INR 25 lakhs in
            a financial year. This exemption reduces compliance burdens compared
            to other entities, provided the specified thresholds are not
            breached.
          </p>

          {/* Compliance Penalties */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Compliance Penalties
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Failure to meet compliance deadlines can result in substantial
            fines, with penalties reaching up to INR 5 lakhs for LLPs.
            Consistent non-compliance may lead to legal actions or restrictions,
            emphasizing the need for timely filings.
          </p>

          {/* Filing Checklist */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Filing Checklist
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Annual compliance involves filing Form LLP-11 with the Registrar of
            Companies (RoC) within 60 days from March 31st, due by May 30th each
            year. This form, adhering to the prescribed format, must be
            submitted regardless of business activity, ensuring continuous legal
            standing.
          </p>

          {/* Entity Characteristics */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Entity Characteristics
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            LLPs possess a separate legal identity, allowing them to sue or be
            sued, open bank accounts, employ staff, enter contracts, and raise
            funds from partners, banks, or NBFCs. Partners are not liable for
            each other’s misconduct, and the entity can continue with a single
            partner temporarily without dissolution.
          </p>

          {/* Required Documentation */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Required Documentation
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Essential documents include the LLP incorporation certificate,
            partnership agreement, audited financial statements (if applicable),
            and proof of address for the registered office, ensuring all filings
            are supported with accurate records.
          </p>

          {/* Operational Guidelines */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Operational Guidelines
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Partners must maintain meticulous financial records and ensure
            timely MCA submissions. Even with fewer compliance demands than
            companies, adherence to deadlines is critical to avoid severe
            penalties and maintain operational integrity.
          </p>

          {/* Concluding Remarks */}
          <h2
            style={{
              color: "#001F3F",
              fontWeight: 600,
              marginBottom: isMobile ? "4px" : "6px",
              fontFamily: "Times New Roman, Georgia, serif",
              fontSize: isMobile ? "18px" : "24px",
            }}
          >
            Concluding Remarks
          </h2>
          <div
            style={{
              width: "80px",
              height: "3px",
              background: "#22c55e",
              borderRadius: "2px",
            }}
          ></div>
          <p
            style={{
              fontSize: isMobile ? "12px" : "16px",
            }}
          >
            Annual compliance for LLPs is a streamlined yet essential process to
            uphold legal status and avoid penalties. Proactive management and
            expert guidance can ensure adherence to MCA regulations, safeguarding
            the entity’s continuity.
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default AnnualComplianceLLP;